import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ContactCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-28 overflow-hidden" ref={ref}>
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Tibetan%20dzi%20bead%20natural%20crystal%20jade%20bracelet%20energy%20jewelry%20arranged%20on%20warm%20golden%20sand%20surface%20soft%20bokeh%20background%20luxury%20oriental%20aesthetic%20warm%20amber%20tones%20serene%20peaceful%20spiritual%20beauty&width=1920&height=700&seq=contact_cta001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e1a16]/65 via-[#1e1a16]/55 to-[#1e1a16]/75"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-16 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-7">
            <span className="w-12 h-px bg-[#c9a96e]"></span>
            <i className="ri-sparkling-2-line text-[#c9a96e] text-xl"></i>
            <span className="w-12 h-px bg-[#c9a96e]"></span>
          </div>
          <h2
            className="text-white font-bold mb-5 leading-[1.35]"
            style={{
              fontSize: "clamp(1.5rem, 3.5vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            讓我們為你找到
            <br />
            屬於你的守護能量
          </h2>
          <p
            className="text-white/70 leading-[1.75] mb-10 max-w-lg mx-auto"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            每個人都有屬於自己的能量頻率，讓瓏靖陪你找到那件與你共鳴的飾品，帶來守護與祝福。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => { navigate("/products"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="px-10 py-4 bg-[#c9a96e] text-[#1e1a16] rounded-full text-[1rem] font-semibold tracking-widest cursor-pointer hover:bg-[#b8945a] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              探索能量系列
            </button>
            <button
              onClick={() => { navigate("/about"); window.scrollTo({ top: 0, behavior: "smooth" }); }}
              className="px-10 py-4 bg-white/15 backdrop-blur-sm text-white border border-white/40 rounded-full text-[1rem] font-medium tracking-widest cursor-pointer hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              了解品牌故事
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
